import Utilities from "./react-utilities";
import Settings from "./settings";
import { Form, message, Select } from "antd";
import logo from "../../../img/brand/brand.png";
import QRCode from "qrcode";

const CustomFunctions = {
  formatStudentName(student = {}) {
    const firstName = student?.firstName ?? student?.first_name;
    const middleName = student?.middleName ?? student?.middle_name;
    const lastName = student?.lastName ?? student?.last_name;

    return [lastName, firstName, middleName]
      .map((value) => String(value ?? "").trim())
      .filter(Boolean)
      .join(" ");
  },
  buildSelectOptions(data, key = "id", label = "name") {
    return data?.map((v) => {
      return { value: v?.[key], label: v?.[label] };
    });
  },
  async getParams(
    valuesStore,
    isHeadTeacher,
    setClasses,
    setAcadyrs,
    setTerms,
    isForPrimary = true,
  ) {
    await Utilities.sleep(1000);
    const klasses = valuesStore.getValue("klasses");
    const term = valuesStore.getValue("term");
    const acadyr = valuesStore.getValue("academic_year");
    const user = JSON.parse(sessionStorage.getItem("user") || "{}");
    let classes = [];
    if (isHeadTeacher && user && user?.isStaff) {
      //(isHeadTeacher) a flag to differentiate class teacher route and headteacher route for either assessement review or publishment respectively
      if (isForPrimary) {
        classes = klasses
          ?.map((v) => {
            return {
              value: v?.id,
              label: v?.name,
              group: v?.class_group?.toLowerCase(),
            };
          })
          ?.filter((v) => v?.group != "preschool");
      } else {
        classes = klasses
          ?.map((v) => {
            return {
              value: v?.id,
              label: v?.name,
              group: v?.class_group?.toLowerCase(),
            };
          })
          ?.filter((v) => v?.group == "preschool");
      }
    } else {
      if (isForPrimary) {
        classes = klasses
          ?.filter((v) => v?.teacher == user?.id)
          ?.map((v) => {
            return {
              value: v?.id,
              label: v?.name,
              group: v?.class_group?.toLowerCase(),
            };
          })
          ?.filter((v) => v?.group != "preschool");
      } else {
        classes = klasses
          ?.filter((v) => v?.teacher == user?.id)
          ?.map((v) => {
            return {
              value: v?.id,
              label: v?.name,
              group: v?.class_group?.toLowerCase(),
            };
          })
          ?.filter((v) => v?.group == "preschool");
      }
    }
    setClasses(classes);
    setAcadyrs(CustomFunctions.buildSelectOptions(acadyr, "id", "acadyr"));
    // Sort terms by name (numeric-aware) so the dropdown always reads
    // Term 1, Term 2, Term 3 regardless of the order the API returns them.
    const sortedTerms = [...(term || [])].sort((a, b) =>
      String(a?.name ?? "").localeCompare(String(b?.name ?? ""), undefined, {
        numeric: true,
      }),
    );
    setTerms(CustomFunctions.buildSelectOptions(sortedTerms));
  },
  async getStudents(table, data, navigate, callback) {
    table.setLoading(true);
    const res = await Utilities.fetchWithAuth(
      "GET",
      `${Settings?.urls?.academics?.students}?class_id=${data?.classID}&stream_id=${data?.streamID}`,
      undefined,
      navigate,
    );
    if (res?.ok) {
      table.setData(res?.data?.students);
      callback?.();
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
    table.setLoading(false);
  },
  async onDownloadSheet(table, form, excel, templateHeading) {
    // Iterate over every student in the class (table.data holds all of them,
    // regardless of the page currently shown in the paginated table) so the
    // exported sheet covers the entire class and not just the visible page.
    const students = table?.data || [];
    if (!students.length) {
      Utilities.showNotification(
        undefined,
        "There are no students to download",
      );
      return;
    }
    try {
      table?.setLoading?.(true);
      // Yield so the loader paints before the (potentially heavy) export blocks the UI.
      await Utilities.sleep(50);
      const data = students.map((s) => {
        const v = form.getFieldValue(s?.id) || {};
        return [
          s?.id,
          CustomFunctions.formatStudentName(s),
          v?.bot,
          v?.mid,
          v?.internalExam,
          v?.externalExam,
        ];
      });
      await excel.exportXLSX(
        templateHeading,
        data,
        "sheet1",
        `${Utilities.formatDate(new Date()?.toDateString())}_scores.xlsx`,
      );
    } catch (e) {
      Utilities.showNotification(undefined, "Failed to download scores");
    } finally {
      table?.setLoading?.(false);
    }
  },

  async onDownloadTemplate(table, excel, templateHeading) {
    // table.data holds the whole class, so one row per student here covers
    // every page of the paginated table, not only the current one.
    const students = table?.data || [];
    if (!students.length) {
      Utilities.showNotification(
        undefined,
        "There are no students to download",
      );
      return;
    }
    try {
      table?.setLoading?.(true);
      // Yield so the loader paints before the (potentially heavy) export blocks the UI.
      await Utilities.sleep(50);
      const arr = students.map((s) => [
        s?.id,
        CustomFunctions.formatStudentName(s),
        "",
        "",
        "",
        "",
      ]); // one row per student
      await excel.exportXLSX(
        templateHeading,
        arr,
        "sheet1",
        `${Utilities.formatDate(new Date()?.toDateString())}_template.xlsx`,
      );
    } catch (e) {
      Utilities.showNotification(undefined, "Failed to download template");
    } finally {
      table?.setLoading?.(false);
    }
  },
  studentAttendance(navigate, id, setItemToview, row) {
    navigate("./admin/attendance", { state: { row } });
  },
  async getSubjectAssignment(
    setDisabled,
    navigate,
    readOnly,
    details,
    donotMakeRequest = true,
    setDetails,
  ) {
    if (readOnly && donotMakeRequest) return;
    const res = await Utilities.fetchWithAuth(
      "GET",
      `${Settings?.urls?.academics?.subject_assignments}/${details?.id}`,
      undefined,
      navigate,
    );
    if (res?.ok) {
      setDisabled(parseInt(res?.data?.locked));
      setDetails?.((prev) => ({ ...prev, ...res?.data }));
    } else {
      Utilities.showNotification(undefined, res?.msg);
    }
  },

  viewSubjectAssignment(navigate, id, setItemToview, row, readOnly) {
    if (row?.classGroup?.toLowerCase() == "preschool") {
      navigate("./admin/nursery_assessment_entry", {
        state: { row, readOnly },
      });
    } else {
      navigate("./admin/primary_assessment_entry", {
        state: { row, readOnly },
      });
    }
  },
  async submitAccommodation(
    method = "POST",
    applicant,
    selectedAccommodation,
    id,
    navigate,
    callback,
  ) {
    const studentID = id ?? applicant?.studentID ?? applicant?.id;
    if (!studentID || !selectedAccommodation) {
      return false;
    }
    const res = await Utilities.fetchWithAuth(
      method,
      Settings?.urls?.enrollment?.studentAccommodation,
      { studentID, accomodationID: selectedAccommodation },
      navigate,
    );
    if (res?.ok) {
      await callback?.();
      return true;
    }
    Utilities.showNotification(
      undefined,
      Utilities.formatErrorMessage(
        { ...res, msg: res?.data ? undefined : res?.msg },
        "Unable to assign accommodation.",
      ),
    );
    return false;
  },
  async getAccommodations(setAccommodations, navigate, category) {
    const query = category
      ? `?${new URLSearchParams({ category }).toString()}`
      : "";
    const res = await Utilities.fetchWithAuth(
      "GET",
      `${Settings?.urls?.enrollment?.accommodation}${query}`,
      undefined,
      navigate,
    );
    if (res?.ok) {
      setAccommodations?.(res?.data);
      return res.data;
    }
    Utilities.showNotification(
      undefined,
      Utilities.formatErrorMessage(
        { ...res, msg: res?.data ? undefined : res?.msg },
        "Unable to load accommodation venues.",
      ),
    );
    return null;
  },

  async uploadJobCardInvoice(params, setLoading) {
    try {
      // await form.validateFields();
      const { form, locationState, navigate } = params || {};
      const allValues = form?.getFieldsValue();
      const { uploads, totalCost } = allValues || {};
      // console.log(uploads, totalCost, allValues)
      if (!uploads || !totalCost) {
        Utilities.showNotification(undefined, "Please set required fields");
        return;
      }
      setLoading?.(true);
      let result = [];
      for (let file of uploads) {
        const fileObject = file;
        const object = {
          maintenanceRequestID: locationState?.state?.id,
          totalCost,
          files: fileObject?.originFileObj,
        };
        const res = await Utilities.fetchWithAuth(
          "POST",
          Settings?.urls?.transport?.repair_invoice,
          object,
          navigate,
        );
        if (res?.ok) {
          Utilities.showNotification(
            undefined,
            "Job Card invoice upload was successful",
            "text-success",
          );
        } else {
          Utilities.showNotification(undefined, res?.msg);
        }
        result.push(res);
      }
      setLoading?.(false);
      return result;
    } catch (error) {
      console.log(error);
      message.error("Please fill all required fields before continuing");
    }
  },

  async changeStatus(
    table,
    endpoint,
    record,
    action,
    navigate,
    setRecord,
    postRequestKey = "fuelRequestID",
    postValueKey = "id",
    rejectionRemarkRef,
  ) {
    if (!endpoint) return;
    const remarks =
      rejectionRemarkRef?.current?.resizableTextArea?.textArea?.value;
    table.setLoading(true);
    const data = [
      { [postRequestKey]: record?.[postValueKey], action, remarks },
    ];
    const res = await Utilities.fetchWithAuth("POST", endpoint, data, navigate);
    if (res.ok) {
      setRecord?.({ record, action });
    }
    table.setLoading(false);
  },

  async getRecordDetails(
    endpoint,
    row,
    id,
    navigate,
    setRecord,
    makePostRequest = true,
  ) {
    if (makePostRequest) {
      const e = `${endpoint}/${row?.[id]}`;
      const res = await Utilities.fetchWithAuth("GET", e, undefined, navigate);
      if (res.ok) {
        setRecord({ ...res.data, ...row });
      } else {
        Utilities.showNotification(undefined, res.msg);
      }
    } else {
      setRecord(row);
    }
  },

  printCoupon(record, pdfHook) {
    const val = `${Settings.backend}/redeem_coupon?url=${Settings?.urls?.transport?.fuel_coupons_redeem}&couponcode=${record?.couponCode}&litres=${record?.requestLitres}`;
    const name = `${record?.requestNumber}.pdf`;
    const fields = [
      ["Request Number", record?.requestNumber],
      ["Driver Name", record?.driverName],
      ["Bus Registration Number Plate", record?.busPlateNumber],
      ["Litres", record?.requestLitres],
      ["Coupon Code", record?.couponCode],
      ["Date", Utilities.formatDate(record?.date || record?.issuedAt)],
      ["Purpose", record?.purpose],
    ];
    pdfHook?.generatePdf(async (pdf, { pageWidth }) => {
      const logoWidth = 30;
      const logoHeight = 30;
      const x = 14;
      const lineHeight = 9;
      let y = 10;

      pdf.addImage(
        logo,
        "PNG",
        pageWidth / 2 - logoWidth / 2,
        y,
        logoWidth,
        logoHeight,
      );
      y += logoHeight + 8;

      pdf.setFontSize(16);
      pdf.setFont("helvetica", "bold");
      pdf.text(Settings?.institution?.name || "", pageWidth / 2, y, {
        align: "center",
      });
      y += lineHeight + 2;

      pdf.setFontSize(13);
      pdf.text("Fuel Coupon", pageWidth / 2, y, { align: "center" });
      y += lineHeight + 6;

      pdf.setFontSize(12);
      fields.forEach(([label, value]) => {
        pdf.setFont("helvetica", "bold");
        pdf.text(`${label}: `, x, y);
        const labelWidth = pdf.getTextWidth(`${label}: `);
        pdf.setFont("helvetica", "normal");
        pdf.text(`${value ?? ""}`, x + labelWidth, y);
        y += lineHeight;
      });

      y += 4;
      const qrSize = 50;
      const qrDataUrl = await QRCode.toDataURL(val, { width: qrSize });
      pdf.addImage(
        qrDataUrl,
        "PNG",
        pageWidth / 2 - qrSize / 2,
        y,
        qrSize,
        qrSize,
      );
    }, name);
  },

  printRepairJobCard(record, pdfHook) {
    // console.log(record)
    const name = `${record?.maintenanceRequestNumber || "repair-jobcard"}.pdf`;
    pdfHook.generatePdf(async (pdf, { pageWidth }) => {
      // Logo
      const logoWidth = 40;
      const logoHeight = 40;
      pdf.addImage(
        logo,
        "PNG",
        pageWidth / 2 - logoWidth / 2,
        10,
        logoWidth,
        logoHeight,
      );

      // Title
      pdf.setFontSize(16);
      pdf.text(Settings?.institution?.name, pageWidth / 2, 60, {
        align: "center",
      });
      pdf.setFontSize(14);
      pdf.text("Vehicle Maintenance Job Card", pageWidth / 2, 70, {
        align: "center",
      });

      // Fields
      pdf.setFontSize(12);
      let y = 80;
      const lineHeight = 10;
      const fields = [
        ["Request Number", record?.maintenanceRequestNumber],
        ["Status", record?.status],
        ["Maintenance Type", record?.maintenanceType],
        ["Bus Plate Number", record?.busPlateNumber],
        ["Issue", record?.issue],
        ["Details", record?.description],
        ["Date", record?.createdAt],
      ];
      fields.forEach(([label, value]) => {
        pdf.text(`${label}: ${value}`, 20, y);
        y += lineHeight;
      });
    }, name);
  },
  categoryRules: {
    birthCert: {
      name: "Birth Certificate",
      required: true,
      mimeTypes: ["image/jpeg", "image/png", "application/pdf"],
    },
    reportCard: {
      name: "Report Card",
      required: false,
      mimeTypes: ["image/jpeg", "image/png", "application/pdf"],
    },
    passportPhoto: {
      name: "Passport Photo",
      required: true,
      mimeTypes: ["image/jpeg", "image/png"],
    },
    parentIDCard: {
      name: "Parent ID Card",
      required: true,
      mimeTypes: ["image/jpeg", "image/png", "application/pdf"],
    },
  },
  setFilesObject(uploadedFiles) {
    if (uploadedFiles && uploadedFiles?.data?.length) {
      return uploadedFiles?.data?.map((file, index) => {
        return {
          id: file?.id,
          uid: file?.id || index,
          name: file?.fileName,
          category: file?.fileType,
          // url: `${Settings.backend}/${file.file}`,
          url: file.file,
          admissionID: file?.admissionID,
          rowId: file?.rowId || file?.id,
        };
      });
    }
    return [];
  },

  async getDataFromDB(admissionID, navigate) {
    if (!admissionID) return;
    const urls = {
      student: Settings.urls.enrollment.adm_student,
      emergency: Settings.urls.enrollment.adm_emergency,
      guardian: Settings.urls.enrollment.adm_guardian,
      uploads: Settings.urls.enrollment.adm_uploads,
      get_application: Settings.urls.enrollment.get_application,
      interview: Settings?.urls.enrollment.adm_interview,
    };

    let data = {};
    let dataInGroups = {};
    let uploadedFiles = null;
    for (let key in urls) {
      const res = await Utilities.fetchWithAuth(
        "GET",
        `${urls[key]}/${admissionID}`,
        { admissionID },
        navigate,
      );
      // console.log(res);
      if (res?.ok && key != "uploads") {
        data = { ...data, ...res.data };
        dataInGroups[key] = res.data;
      }
      if (res?.ok && key == "uploads") {
        uploadedFiles = res.data;
      }
    }
    return { data, dataInGroups, uploadedFiles };
  },
  prefixSelector: (name) => {
    return (
      <Form.Item name={name} noStyle>
        <Select
          options={[
            { value: "+256", label: "+256" },
            { value: "+233", label: "+233" },
            { value: "+234", label: "+234" },
          ]}
          style={{ width: 100 }}
        />
      </Form.Item>
    );
  },

  myStyle(token) {
    const contentStyle = {
      color: token.colorTextTertiary,
      // backgroundColor: '#ebebeb',
      borderRadius: token.borderRadiusLG,
      // border: `2px dashed ${token.colorBorder}`,
    };
    return { contentStyle };
  },

  tblCaption(data) {
    return <label>Total Count: {data?.length}</label>;
  },
};

export default CustomFunctions;
